import { useMemo } from 'react';
import {
    GroupTableCustomSortComparators,
    GroupTableMetrics,
} from '@/components/group-tables/group-table-view-model-primitives';
import { useGroupTableNameFilterSortViewModel } from '@/components/group-tables/use-group-table-name-filter-sort-view-model';

type UseGroupTableDomainViewModelArgs<TEntity, TData extends GroupTableMetrics> = {
    entities: TEntity[];
    mapEntityToData: (entity: TEntity) => TData;
    page: number;
    rowsOnPage: number;
    setPage: (page: number) => void;
    setPageCount: (count: number) => void;
    setTotalRows: (count: number) => void;
    sortComparators: GroupTableCustomSortComparators<TData>;
    filterData: (item: TData, normalizedNameFilter: string) => boolean;
};

export const useGroupTableDomainViewModel = <TEntity, TData extends GroupTableMetrics>({
    entities,
    mapEntityToData,
    page,
    rowsOnPage,
    setPage,
    setPageCount,
    setTotalRows,
    sortComparators,
    filterData,
}: UseGroupTableDomainViewModelArgs<TEntity, TData>) => {
    const data = useMemo(() => entities.map((entity) => mapEntityToData(entity)), [entities, mapEntityToData]);
    const nameFilterSortViewModel = useGroupTableNameFilterSortViewModel<TData>({
        data,
        page,
        rowsOnPage,
        setPage,
        setPageCount,
        setTotalRows,
        filterData,
        sortComparators,
    });

    return {
        data,
        ...nameFilterSortViewModel,
    };
};
